


class Profile{
	constructor(api, axios, helper){
		this.api   				= api;
		this.axios 				= axios;
		this.Helper  			= helper;
		this.list_profiles  	= {};
		this.list_sessions  	= {};
		this.profile 			= null;
		this.timer 				= null; 
		// this.index_profile  	= null;		
		this.save_session();
	}
	save_session(key, layout = null, options = null){
		// let temp = null;
		// console.log("Save save_session")
		if (layout) {			
			this.Helper.set_local_session('profile', { ...layout})
			// this.update_sessions({...layout});
		}
		if (options) {
			this.Helper.set_local_session('grid_options', { ...options})	
		}
	
	}
	check_session_active(){
		let temp = this.Helper.get_local("profiles_dashboard_sessions");
		if (temp && temp.length > 0) {
			let idx = temp.findIndex( x => (x && !x.is_active)) 
			if (idx >= 0) {
				// this.index_profile 	= idx;
				this.timer_active(temp, idx);

				return temp[idx];
			}
		}
		return null
	}

	timer_active(temp, idx){
		if (!this.timer) {

			temp[idx].is_active = true;
			this.Helper.set_local("profiles_dashboard_sessions", temp);
			this.timer = setTimeout(()=>{
				temp[idx].is_active = false;
				this.Helper.set_local("profiles_dashboard_sessions", temp);
				clearTimeout(this.timer);
				this.timer 			= null;
			},30000)
		}else{
			temp[idx].is_active = true;
			this.Helper.set_local("profiles_dashboard_sessions", temp);
		}
	}

	update_sessions(lay){
		if (lay) {
			let temp = this.Helper.get_local("profiles_dashboard_sessions");
			if (temp && temp.length > 0) {
				let idx = temp.findIndex( x => (x && !x.is_active)) 
				if (idx >= 0) {
					// this.index_profile 	= idx;
					temp[idx]  			= lay;
					temp[idx].is_active = false;
					this.timer_active(temp, idx);

				}else{
					lay.is_active = false;
					temp.push(lay);
					this.timer_active(temp, temp.length - 1);

				}
				
			}else{
				temp 			= [];
				lay.is_active 	= false;
				temp.push(lay);
				this.timer_active(temp, temp.length - 1);

			}
			// this.Helper.set_local("list_profiles_dashboard", temp);
			
		}
	} // update sessions

	get_profile(key, item = 'profile'){
		let temp = null;
		
		if (key == 'dashboard') {			
			temp = this.Helper.get_local_session(item);
			// console.log(" profile --------------------------> ", temp )
			if (temp) {				
				return temp;
			}/*else{
				temp = this.check_session_active();
				if (temp) {
					return temp;
				}
			}*/
		}
		return null;
	}



}
export default Profile;